import React, { useState } from 'react';
import { Box, Fade, IconButton } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

type AddBetweenButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

export const AddBetweenButton: React.FC<AddBetweenButtonProps> = ({
  onClick,
  disabled
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={!disabled ? onClick : undefined}
      sx={{
        height: isHovered ? '32px' : '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'default' : 'pointer',
        transition: 'all 0.2s ease',
        position: 'relative',
        margin: '2px 0'
      }}
    >
      <Fade in={isHovered && !disabled}>
        <Box
          sx={{
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            width: '100%'
          }}
        >
          <Box
            sx={{
              flex: 1,
              height: '1px',
              backgroundColor: 'primary.main',
              opacity: 0.3
            }}
          />
          <IconButton
            size="small"
            sx={{
              width: 24,
              height: 24,
              backgroundColor: 'background.paper',
              border: '1px solid',
              borderColor: 'primary.main',
              boxShadow: 1,
              '&:hover': {
                backgroundColor: 'primary.light',
                borderColor: 'primary.main'
              }
            }}
          >
            <AddIcon sx={{ fontSize: 14, color: 'primary.main' }} />
          </IconButton>
          <Box
            sx={{
              flex: 1,
              height: '1px',
              backgroundColor: 'primary.main',
              opacity: 0.3
            }}
          />
        </Box>
      </Fade>
    </Box>
  );
};
